const useTabs = (i18n, isChatEnabled, isQAEnabled) => [
  { id: 1, name: i18n.info.label, hidden: false },
  { id: 2, name: i18n.qa.label, hidden: !isQAEnabled },
  { id: 3, name: i18n.social.label, hidden: !isChatEnabled },
];

export { useTabs };
